import { useState, useCallback } from "react";
import { useAuth } from "src/contexts/auth-provider";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { GET_STORE_PRINTERS } from "src/constants/queries";
import { StorePrinter } from "src/interfaces/menu.interface";

export const useStorePrinters = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const [storePrinters, setStorePrinters] = useState<StorePrinter[]>([]);
  const [isLoadingPrinters, setIsLoadingPrinters] = useState(false);

  const fetchStorePrinters = useCallback(async () => {
    if (!hasRestaurant?.correlationId) return;

    setIsLoadingPrinters(true);

    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: GET_STORE_PRINTERS,
        variables: {
          storeCorrelationId: hasRestaurant.correlationId,
        },
      });

      if (data?.data?.storePrinters) {
        setStorePrinters(data.data.storePrinters as StorePrinter[]);
      }
    } catch (err) {
      console.error("Error fetching printers:", err);
    } finally {
      setIsLoadingPrinters(false);
    }
  }, [axBe, hasRestaurant?.correlationId]);

  return {
    storePrinters,
    isLoadingPrinters,
    fetchStorePrinters,
  };
};

